module.exports = __webpack_public_path__ + "img/aston-blog.17eaa24e.jpg";